import { unsafeCSS, html } from "lit";
import { property, queryAssignedElements } from "lit/decorators.js";
import { LeafElement } from "../../components/leaf-element.js";
const styles = "/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n:host([color=green]) {\n  --leafdcws-heading-list-counter-background-color: var(--leafdcws-accent-2-xstrong);\n  --leafdcws-heading-list-counter-color: var(--leaf-color-content-knockout);\n}\n\n:host([color=orange]) {\n  --leafdcws-heading-list-counter-background-color: var(--leafdcws-accent-1-subtle);\n  --leafdcws-heading-list-counter-color: var(--leaf-color-content-brand-strong);\n}\n\n.chc-c-heading-list ::slotted([slot=item]) {\n  margin-bottom: var(--leaf-spacing-24);\n}\n.chc-c-heading-list ::slotted([slot=item]:last-child) {\n  margin-bottom: 0;\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const _CHCHeadingList = class _CHCHeadingList extends LeafElement {
  constructor() {
    super(...arguments);
    this.color = "green";
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("chc-heading-list-item:updated", this.updateCounter);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener("chc-heading-list-item:updated", this.updateCounter);
  }
  updateCounter() {
    var _a, _b;
    for (let i = 0; i <= this.listItems.length; i += 1) {
      const element = (_b = (_a = this.listItems[i]) == null ? void 0 : _a.shadowRoot) == null ? void 0 : _b.querySelector(".chc-c-heading-list-item--counter");
      if (element) {
        element.innerHTML = String(i + 1);
      }
    }
  }
  render() {
    return html`<div class="chc-c-heading-list" role="list" part="base">
      <slot name="item" part="item"></slot>
    </div>`;
  }
};
_CHCHeadingList.styles = unsafeCSS(styles);
let CHCHeadingList = _CHCHeadingList;
__decorateClass([
  property({ reflect: true })
], CHCHeadingList.prototype, "color", 2);
__decorateClass([
  queryAssignedElements({ slot: "item" })
], CHCHeadingList.prototype, "listItems", 2);
export {
  CHCHeadingList
};
//# sourceMappingURL=heading-list.component.js.map
